import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable import/no-extraneous-dependencies */


import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
export default (function (reducers, initialState) {
  var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var options = _objectSpread({}, opts);

  var reducer = combineReducers(reducers);
  var enhancer = applyMiddleware.apply(void 0, _toConsumableArray(middlewares).concat([thunk, promise]));

  if (process.env.NODE_ENV !== 'production') {
    var _options$devTools = options.devTools,
        devTools = _options$devTools === void 0 ? {} : _options$devTools;
    var composeEnhancers = composeWithDevTools(devTools);
    enhancer = composeEnhancers(enhancer);
  }

  return createStore(reducer, initialState, enhancer);
});